<script setup>
import { useRoute } from 'vue-router';
import WpPage from '@/components/WpPage.vue';

const route = useRoute();
const pageSlug = route.params.slug;

</script>

<template>
  <WpPage :page-slug="pageSlug" />
</template>
